const validateName = (name) => {
  const trimmedName = name.trim();

  if (!trimmedName.length) {
    return {
      isValid: false,
      message: 'This field is required',
      translationKey: 'this_field_is_required',
    };
  }

  if (trimmedName.length < 3) {
    return {
      isValid: false,
      message: 'Should contain minimum 3 letters',
      translationKey: 'should_contain_minimum_3_letters',
    };
  }

  if (trimmedName.length > 20) {
    return {
      isValid: false,
      message: 'Maximum character limit is exceeded',
      translationKey: 'max_char_limit_is_exceeded',
    };
  }

  if (!trimmedName.includes(' ')) {
    return {
      isValid: false,
      message: 'Please enter your full name',
      translationKey: 'please_enter_your_full_name',
    };
  }

  if (!/^[A-Za-zԱ-Ֆա-ֆև]+$/.test(trimmedName.replace(/ /g, ''))) {
    return {
      isValid: false,
      message: 'Only Latin/Armenian letters are accepted',
      translationKey: 'only_Latin_Armenian_letters_accepted',
    };
  }

  return { isValid: true, message: '', translationKey: '' };
};

const validatePhone = (number) => {
  const trimmedNumber = number.trim();

  if (!trimmedNumber.length) {
    return {
      isValid: false,
      message: 'This field is required',
      translationKey: 'this_field_is_required',
    };
  }
  if (trimmedNumber.length !== 11) {
    return {
      isValid: false,
      message: 'Wrong number format',
      translationKey: 'wrong_number_format',
    };
  }
  if (!/^[0-9-]+$/.test(trimmedNumber)) {
    return {
      isValid: false,
      message: 'Only digits are accepted',
      translationKey: '"only_digits_are_accepted"',
    };
  }

  return { isValid: true, message: '', translationKey: '' };
};

const validateEmail = (email) => {
  const trimmedEmail = email.trim();

  if (!trimmedEmail.length) {
    return {
      isValid: false,
      message: 'This field is required',
      translationKey: 'this_field_is_required',
    };
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(trimmedEmail)) {
    return {
      isValid: false,
      message: 'Invalid email format',
      translationKey: 'invalid_email_format',
    };
  }

  return { isValid: true, message: '', translationKey: '' };
};

const validatePurpose = (purpose) => {
  const trimmedPurpose = purpose.trim();

  if (!trimmedPurpose.length) {
    return {
      isValid: false,
      message: 'This field is required',
      translationKey: 'this_field_is_required',
    };
  }

  if (trimmedPurpose.length < 3) {
    return {
      isValid: false,
      message: 'Should contain minimum 3 letters',
      translationKey: 'should_contain_minimum_3_letters',
    };
  }

  if (trimmedPurpose.length > 50) {
    return {
      isValid: false,
      message: 'Maximum character limit is exceeded',
      translationKey: 'max_char_limit_is_exceeded',
    };
  }

  return { isValid: true, message: '', translationKey: '' };
};

const validateMessage = (message) => {
  const trimmedMessage = message.trim();

  if (!trimmedMessage.length) {
    return {
      isValid: false,
      message: 'This field is required',
      translationKey: 'this_field_is_required',
    };
  }

  if (trimmedMessage.length < 10) {
    return {
      isValid: false,
      message: 'Should contain minimum 10 letters',
      translationKey: 'should_contain_minimum_10_letters',
    };
  }

  if (trimmedMessage.length > 2000) {
    return {
      isValid: false,
      message: 'Maximum character limit is exceeded',
      translationKey: 'max_char_limit_is_exceeded',
    };
  }

  return { isValid: true, message: '', translationKey: '' };
};

const validateFile = (file) => {
  if (file && file.size > 5 * 1024 * 1024) {
    // 5MB limit
    return {
      isValid: false,
      message: 'File size exceeds 5MB limit',
      translationKey: 'file_size_exceeds_5MB_limit',
    };
  }

  return { isValid: true, message: '', translationKey: '' };
};

function validate(fieldName, value) {
  switch (fieldName) {
    case 'contactName':
      return validateName(value);
    case 'contactEmail':
      return validateEmail(value);
    case 'contactPhone':
      return validatePhone(value);
    case 'contactPurpose':
      return validatePurpose(value);
    case 'contactMessage':
      return validateMessage(value);
    case 'contactFile':
      return validateFile(value);

    default:
      return {
        isValid: false,
        message: 'Something is wrong',
        translationKey: 'something_is_wrong',
      };
  }
}

export function validateForm(formData, tr) {
  const errors = {};

  // eslint-disable-next-line guard-for-in
  for (const fieldName in formData) {
    const value = formData[fieldName];
    const validationResult = validate(fieldName, value);

    const { translationKey, message } = validationResult;
    errors[fieldName] = tr(translationKey, { isError: true }) || message;
  }

  return errors;
}
